.graphs {
    display: flex;
    width: 100%;
    padding: 20px 0px;
    align-items: stretch;
    gap: 20px;
}

.graphContainer {
    height: 300px;
    padding-top: 10px;
    margin: 0px -20px;
}

.assessmentScheduleBox {
    float: left;
    margin: 5px;
}
.assessmentScheduleBox:hover {
    cursor: pointer;
}

.assessmentTitle {
    text-align: center;
    text-transform: uppercase;
}

.assessmentNumber {
    text-align: center;
    letter-spacing: 0.1px;
    color: #f3f7fa;
    text-transform: uppercase;
    font-size: 40px;
    font-family: var(--hps-primary-font);
    font-weight: bolder;
}

.overdueNumber {
    text-align: center;
    letter-spacing: 0.1px;
    color: var(--hps-yellow);
    text-transform: uppercase;
    font-size: 40px;
    font-family: var(--hps-primary-font);
    font-weight: bolder;
}

.controlGroupHeader {
    text-align: left;
    padding: 20px 0px 0px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    margin: 0px;
}

.progressBar {
    margin: 0px 0px 10px 0px;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.headerButtons {
    display: flex;
    gap: 20px;
}

.alertsAssessment {
    width: 50%;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 20px;
}

.assessmentSchedule {
    display: flex;
    justify-content: space-between;
}
